import React, { useCallback, useState } from "react"
import { useInView } from "react-intersection-observer"
import { Flex } from "../../styles/base-styles"
import styled, { css } from "styled-components"
import { HeaderContents } from "./header-contents"

interface HeaderProps {
  isTopPage?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ isTopPage = false }) => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    initialInView: true,
  })

  return (
    <>
      <HeaderGrid ref={ref}>
        <HeaderContents isPrimaryHeading={isTopPage} /> 
      </HeaderGrid>
      {/* ------------------------- Floating Menu --------------------------- */}
      <FloatingTopMenuBar inView={inView}>
        <HeaderGrid>
          <HeaderContents isPrimaryHeading={false} /> 
        </HeaderGrid>
      </FloatingTopMenuBar>
    </>
  )
}
const FloatingTopMenuBar = styled.div<{ inView?: boolean }>`
  position: fixed;
  transition: 0.2s;
  top: 0;
  width: 100%;
  opacity: ${({ inView }) => (inView ? 0 : 1)};
  transform: ${({ inView }) => (inView ? "translateY(-100%)" : "none")};
  z-index: 5000;
  background: white;
  pointer-events: ${({ inView }) => (inView ? "none" : "all")};
`
const HeaderGrid = styled.header`
  position: relative;
  display: grid;
  grid-template-columns: calc((100vw - 1304px) / 2) repeat(12, 1fr) calc(
      (100vw - 1304px) / 2
    );
  width: 100%;
  column-gap: 32px;
  height: 123px;
  @media screen and (max-width: 767px) {
    display: grid;
    grid-template-columns: 24 1fr 24;
    column-gap: 0;
    height: auto;
  }
`
